import React, { useEffect, useState } from "react";
import "./Form.scss";
import { useFormData } from "../../../context/FormContext";

const ratings = ["фуу...", "нее", "хз", "норм", "ваау!!"];

function FlowerCard({
  image,
  flowerKey,
  rating,
  readOnly = false,
  onChangeRating,
}) {
  const currentIndex = ratings.indexOf(rating);

  const updateRating = (newIndex) => {
    const newRating = ratings[newIndex];
    onChangeRating?.(flowerKey, newRating);
  };

  const goLeft = (e) => {
    e.preventDefault();
    updateRating((currentIndex - 1 + ratings.length) % ratings.length);
  };

  const goRight = (e) => {
    e.preventDefault();
    updateRating((currentIndex + 1) % ratings.length);
  };

  return (
    <div className="flower-card">
      <img src={image} alt="flower" className="flower-img" />
      <div className="flower-rating">
        <button className="flower-btn" onClick={goLeft} disabled={readOnly}>
          &lt;
        </button>
        <span className="flower-span">{rating}</span>
        <button className="flower-btn" onClick={goRight} disabled={readOnly}>
          &gt;
        </button>
      </div>
    </div>
  );
}

function Form({ clientData = null }) {
  const { formData, setFormData } = useFormData();
  const [bouquetOptions, setBouquetOptions] = useState([]);
  const [colorOptions, setColorOptions] = useState([]);
  const [filteredFlowers, setFilteredFlowers] = useState([]);
  const urlLink = process.env.REACT_APP_API_URL;

  const isReadOnly = Boolean(clientData);

  const toggleBouquet = (id) => {
    if (isReadOnly) return;
    const updated = formData.selectedBouquets.includes(id)
      ? formData.selectedBouquets.filter((i) => i !== id)
      : [...formData.selectedBouquets, id];
    setFormData((prev) => ({ ...prev, selectedBouquets: updated }));
  };

  const toggleColor = (id) => {
    if (isReadOnly) return;
    const updated = formData.selectedColors.includes(id)
      ? formData.selectedColors.filter((i) => i !== id)
      : [...formData.selectedColors, id];
    setFormData((prev) => ({ ...prev, selectedColors: updated }));
  };

  const handleRatingChange = (flowerId, newRating) => {
    if (isReadOnly) return;
    setFormData((prev) => ({
      ...prev,
      ratings: {
        ...prev.ratings,
        [flowerId]: newRating,
      },
    }));
  };

  useEffect(() => {
    if (isReadOnly) return;

    fetch(`${urlLink}api/flower-type/`)
      .then((res) => res.json())
      .then((data) => {
        setBouquetOptions(data);
        const allIds = data.map((item) => item.id);
        setFormData((prev) => ({ ...prev, selectedBouquets: allIds }));
      });

    fetch(`${urlLink}api/flower-colour/`)
      .then((res) => res.json())
      .then((data) => {
        setColorOptions(data);
        const allIds = data.map((item) => item.id);
        setFormData((prev) => ({ ...prev, selectedColors: allIds }));
      });

    const name = localStorage.getItem("userName") || "";
    setFormData((prev) => ({ ...prev, name }));
  }, []);

  useEffect(() => {
    if (isReadOnly) return;

    fetch(`${urlLink}api/flower/`)
      .then((res) => res.json())
      .then((data) => {
        const filtered = data.filter(
          (item) =>
            formData.selectedBouquets.includes(item.type) &&
            formData.selectedColors.includes(item.colour)
        );
        setFilteredFlowers(filtered);

        const updatedRatings = { ...formData.ratings };
        filtered.forEach((flower) => {
          if (!updatedRatings[flower.id]) {
            updatedRatings[flower.id] = "фуу...";
          }
        });
        setFormData((prev) => ({ ...prev, ratings: updatedRatings }));
      });
  }, [formData.selectedBouquets, formData.selectedColors]);

  const displayBouquets = isReadOnly ? clientData.flower_type : bouquetOptions;

  const displayColors = isReadOnly ? clientData.flower_colour : colorOptions;

  const displayFlowers = isReadOnly
    ? clientData.chosen_flowers.map((item) => ({
        id: item.flower.id,
        image: item.flower.image,
        rating: item.text,
      }))
    : filteredFlowers.map((flower) => ({
        id: flower.id,
        image: flower.image,
        rating: formData.ratings?.[flower.id] || "фуу...",
      }));

  return (
    <div className="form">
      <div className="form__dp">
        <div className="container">
          <div className="form__container">
            <form className="form__form">
              <p className="form__header">Вот что ей нравится:</p>
              <ul className="form__buket-list">
                {displayBouquets.map((item) => (
                  <li
                    key={item.id}
                    className="form__buket-item"
                    onClick={() => toggleBouquet(item.id)}
                  >
                    <div
                      className="green-dot"
                      style={{
                        backgroundColor: (
                          isReadOnly
                            ? item.selected
                            : formData.selectedBouquets.includes(item.id)
                        )
                          ? "#90ee90"
                          : "red",
                      }}
                    ></div>
                    <img src={item.image} alt={item.name} />
                    <div className="label">{item.name}</div>
                  </li>
                ))}
              </ul>

              <p className="form__header">Еще..</p>
              <ul className="form__type-list">
                {displayColors.map((item) => (
                  <li
                    key={item.id}
                    className="form__type-item"
                    onClick={() => toggleColor(item.id)}
                  >
                    <div
                      className="green-dot"
                      style={{
                        backgroundColor: (
                          isReadOnly
                            ? item.selected
                            : formData.selectedColors.includes(item.id)
                        )
                          ? "#90ee90"
                          : "red",
                      }}
                    ></div>
                    <img src={item.image} alt={item.name} />
                    <div className="label">{item.name}</div>
                  </li>
                ))}
              </ul>

              <p className="form__header">Не всегда же розы ?? или все же?</p>
              <div className="form__rating-list-wrapper">
                <div className="flower-rating-list">
                  {displayFlowers.map((flower) => (
                    <FlowerCard
                      key={flower.id}
                      flowerKey={flower.id}
                      image={flower.image}
                      rating={flower.rating}
                      readOnly={isReadOnly}
                      onChangeRating={handleRatingChange}
                    />
                  ))}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Form;
